import React from 'react';

export default function LoadingDots({ color = 'currentColor', size = 6 }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: Math.max(3, size * 0.6) }}>
      <span
        className="loading-dot"
        style={{
          width: size, height: size, borderRadius: '50%',
          background: color, display: 'inline-block',
          animation: 'loadingDot 1.4s ease-in-out 0s infinite',
        }}
      />
      <span
        className="loading-dot"
        style={{
          width: size, height: size, borderRadius: '50%',
          background: color, display: 'inline-block',
          animation: 'loadingDot 1.4s ease-in-out 0.2s infinite',
        }}
      />
      <span
        className="loading-dot"
        style={{
          width: size, height: size, borderRadius: '50%',
          background: color, display: 'inline-block',
          animation: 'loadingDot 1.4s ease-in-out 0.4s infinite',
        }}
      />
    </span>
  );
}
